import { render, staticRenderFns } from "./FormAlarmLimitSensorVsd.vue?vue&type=template&id=1bf2c374&scoped=true"
import script from "./FormAlarmLimitSensorVsd.vue?vue&type=script&lang=ts"
export * from "./FormAlarmLimitSensorVsd.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf2c374",
  null
  
)

export default component.exports